<template>
    <div class="agreement-wrapper">
        <Information name="declare"/>
    </div>
</template>

<script>

import Information from '@/components/Information.vue'

export default {
    name: 'Declare',
    components: {
        Information
    }
}
</script>
